import React from "react";
import { useSelector } from "react-redux";
import {
  selectHelenaState,
  shouldShowHelenaUserActivationPopup,
} from "store/reducers/helena.reducer";
import { I18nextProvider, useTranslation } from "react-i18next";
import { HelenaStatusEnum } from "model/helena.model";
import { i18nUserContext } from "config/translations/I18n";
import { Alert } from "@cc/react-components";
import Page from "ui/Page";
import HelenaUserRegistrationCard from "../HelenaRegistration/HelenaUserRegistrationCard";

export interface Props extends React.HTMLAttributes<HTMLElement> {}

const HelenaUserActivation = ({ children }: Props) => {
  const [t] = useTranslation();
  const inviteUserToHelena = useSelector(shouldShowHelenaUserActivationPopup);
  const { status: helenaStatus } = useSelector(selectHelenaState);

  const renderStatusUp = () => {
    if (inviteUserToHelena) {
      return (
        <HelenaUserRegistrationCard
          messageKey={"helena.user.notRegistered.info"}
        />
      );
    } else {
      return <>{children}</>;
    }
  };

  return (
    <Page.Scrollable>
      <Page.Body>
        <I18nextProvider i18n={i18nUserContext}>
          {helenaStatus === HelenaStatusEnum.DOWN && (
            <Alert variant="danger">{t("helena.down")}</Alert>
          )}
          {helenaStatus === HelenaStatusEnum.UP && renderStatusUp()}
        </I18nextProvider>
      </Page.Body>
    </Page.Scrollable>
  );
};

export default HelenaUserActivation;
